var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 4.16666C3.33325 2.78594 4.45254 1.66666 5.83325 1.66666H10.6311C11.2941 1.66666 11.93 1.93005 12.3988 2.39889L15.9344 5.93442C16.4032 6.40326 16.6666 7.03915 16.6666 7.70219V15.8333C16.6666 17.214 15.5473 18.3333 14.1666 18.3333H5.83325C4.45254 18.3333 3.33325 17.214 3.33325 15.8333V4.16666ZM14.1666 17.3333H5.83325C5.00482 17.3333 4.33325 16.6618 4.33325 15.8333V4.16666C4.33325 3.33823 5.00482 2.66666 5.83325 2.66666H10.6311C10.6708 2.66666 10.7105 2.66824 10.7498 2.67136V5.83332C10.7498 6.79982 11.5333 7.58332 12.4998 7.58332H15.6619C15.665 7.62273 15.6666 7.66238 15.6666 7.70219V15.8333C15.6666 16.6618 14.995 17.3333 14.1666 17.3333ZM15.169 6.58332L11.7498 3.16412V5.83332C11.7498 6.24754 12.0856 6.58332 12.4998 6.58332H15.169Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43816 9.20153C8.43816 8.72186 8.04964 8.33334 7.56997 8.33334C7.0903 8.33334 6.70179 8.72186 6.70179 9.20153C6.70179 9.6812 7.0903 10.0697 7.56997 10.0697C8.04964 10.0697 8.43816 9.6812 8.43816 9.20153Z",
    fill: "#5B5C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00724 14.7145H13.9945C14.1378 14.7145 14.2203 14.5474 14.1269 14.4345L11.1643 10.6579C11.148 10.6372 11.1273 10.6204 11.1036 10.6088C11.0799 10.5973 11.0539 10.5913 11.0275 10.5913C11.0012 10.5913 10.9752 10.5973 10.9515 10.6088C10.9278 10.6204 10.907 10.6372 10.8908 10.6579L9.20216 12.811L8.3101 11.6737C8.29386 11.6529 8.2731 11.6361 8.24941 11.6246C8.22572 11.6131 8.19971 11.6071 8.17336 11.6071C8.14701 11.6071 8.121 11.6131 8.09731 11.6246C8.07362 11.6361 8.05286 11.6529 8.03662 11.6737L5.8705 14.4345C5.78151 14.5474 5.86182 14.7145 6.00724 14.7145Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFile);
export default __webpack_public_path__ + "static/media/imgFile.cdb76dd35317b338d2d3d141471e6b81.svg";
export { ForwardRef as ReactComponent };